import React, { useState } from 'react';
import '../styles/ApiKeyGenerator.css';

const generateUUID = () => {
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }
  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return template.replace(/[xy]/g, c => {
    const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const generateHex = (length: number = 32) => {
  const bytes = new Uint8Array(length / 2);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
};

const generateBase64 = (length: number = 32) => {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let binary = '';
  bytes.forEach(b => (binary += String.fromCharCode(b)));
  return btoa(binary);
};

const ApiKeyGenerator: React.FC = () => {
  const [algorithm, setAlgorithm] = useState('uuid');
  const [apiKey, setApiKey] = useState('');

  const handleGenerate = () => {
    let key = '';
    switch (algorithm) {
      case 'uuid':
        key = generateUUID();
        break;
      case 'hex':
        key = generateHex(32);
        break;
      case 'base64':
        key = generateBase64(32);
        break;
      default:
        key = generateUUID();
    }
    setApiKey(key);
  };

  return (
    <div className="api-key-generator">
      <h2>Gerador de API Key</h2>
      <div className="controls">
        <label htmlFor="algorithm">Algoritmo:</label>
        <select
          id="algorithm"
          value={algorithm}
          onChange={e => setAlgorithm(e.target.value)}
        >
          <option value="uuid">UUID</option>
          <option value="hex">Hexadecimal</option>
          <option value="base64">Base64</option>
        </select>
        <button onClick={handleGenerate}>Gerar</button>
      </div>
      {apiKey && (
        <textarea
          className="result"
          readOnly
          value={apiKey}
          rows={2}
        />
      )}
    </div>
  );
};

export default ApiKeyGenerator;
